import React from "react";
import {Link} from "react-router-dom";
import {Partners} from "../../shared/partners";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import {env} from "../../environment";

export const Services = () => {
    const [emblaRef] = useEmblaCarousel({
        align: 'center',
        skipSnaps: true,
        containScroll: 'trimSnaps',
        loop: true,
        draggable: true,
    }, [Autoplay({ delay: 2000 })]);

    return (
        <>
            <section data-bs-version="5.1" className="header3 cid-t9ZviFrsLL mbr-parallax-background" id="header03-v">
                <div className="mbr-overlay" style={{ opacity: "0.3", backgroundColor: "rgb(0, 0, 0)" }}></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-5 d-flex">
                            <div className="link-wrapper">
                                <p className="link mbr-fonts-style display-5">
                                    <strong>WHAT WE OFFER</strong>
                                </p>
                                <span className="mbr-iconfont link-icon mobi-mbri-right mobi-mbri"></span>
                            </div>
                        </div>
                        <div className="col-12 col-lg-8 col-md-7">
                            <h1 className="mbr-section-title align-right mbr-fonts-style pb-5 mb-5 display-5">
                                <strong>Thoughts in Action
                                </strong>
                                <div><strong>Imagination into Reality.</strong></div>
                            </h1>
                        </div>
                    </div>
                </div>
            </section>
            <section data-bs-version="5.1" className="content10 cid-tadSbTTa5X" id="content10-18">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md">
                            <h6 className="mbr-section-subtitle mbr-fonts-style mb-4 display-5">
                                <strong>
                                    Reliable, committed, client-focused,
                                    <br/>
                                    and driven through innovative
                                    <br/>
                                    process solutions.
                                </strong>
                            </h6>
                        </div>
                        <div className="col-md-12 col-lg-6">
                            <p className="mbr-text mbr-fonts-style display-7">
                                We connect expertise across services,
                                markets, and geographies to deliver transformative outcomes. Worldwide, we design,
                                build, finance, operate and manage projects and programs that unlock opportunities,
                                protect our environment and improve people’s lives.
                                <br/><br/>
                                Clients in every region of
                                the world depend on our ability to design, build, finance and operate their most
                                critical projects. Our technical knowledge, local connections and broad market
                                experience allow us to deliver specialized solutions across the entire project life
                                cycle.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section data-bs-version="5.1" className="features10 mbr-embla cid-tafb0T580F" id="features10-1j">
                <div>
                    <div className="container">
                        <div className="embla" ref={emblaRef}>
                            <div className="embla__container container">
                                <div className="embla__slide slider-image item features-image"
                                     style={{ marginLeft: "2rem", marginRight: "2rem" }}>
                                    <div className="card-wrapper">
                                        <div className="card-img card1">
                                        </div>
                                        <div className="card-box">
                                            <h4 className="card-title mbr-white mbr-fonts-style display-7">Our
                                                general contracting team takes pride in their relationships with
                                                subcontractors and other project partners, and works hard to foster
                                                cooperation and mutual respect on all of our project
                                                sites.&nbsp;</h4>
                                        </div>
                                        <div className="card-box1">
                                            <h4 className="card-title1 mbr-white mbr-fonts-style display-5">
                                                General Contractor
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="embla__slide slider-image item features-image"
                                     style={{ marginLeft: "2rem", marginRight: "2rem" }}>
                                    <div className="card-wrapper">
                                        <div className="card-img card2">
                                        </div>
                                        <div className="card-box">
                                            <h4 className="card-title mbr-white mbr-fonts-style display-7">
                                                At {env.siteName}, pre-construction services are not just about
                                                numbers, pricing, subcontractors, and materials or estimations.
                                                Pre-construction is about people.&nbsp;</h4>
                                        </div>
                                        <div className="card-box1">
                                            <h4 className="card-title1 mbr-white mbr-fonts-style display-5">
                                                Pre-Construction Services
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="embla__slide slider-image item features-image"
                                     style={{ marginLeft: "2rem", marginRight: "2rem" }}>
                                    <div className="card-wrapper">
                                        <div className="card-img card3">
                                        </div>
                                        <div className="card-box">
                                            <h4 className="card-title mbr-white mbr-fonts-style display-7">In the
                                                design-build project as a service, we act as a single point of
                                                contact and are solely responsible for project design, quality,
                                                cost, and schedule adherence.</h4>
                                        </div>
                                        <div className="card-box1">
                                            <h4 className="card-title1 mbr-white mbr-fonts-style display-5">
                                                Design-Build Services
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="embla__slide slider-image item features-image"
                                     style={{ marginLeft: "2rem", marginRight: "2rem" }}>
                                    <div className="card-wrapper">
                                        <div className="card-img card4">
                                        </div>
                                        <div className="card-box">
                                            <h4 className="card-title mbr-white mbr-fonts-style display-7">Successful
                                                completion of construction projects requires the right people, the
                                                right approach and the right attitude. Our experienced construction
                                                team members have a proven ability to navigate.</h4>
                                        </div>
                                        <div className="card-box1">
                                            <h4 className="card-title1 mbr-white mbr-fonts-style display-5">
                                                <p>Project Management</p>
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button className="embla__button embla__button--prev">
                                <span className="mobi-mbri mobi-mbri-arrow-prev mbr-iconfont" aria-hidden="true"></span>
                                <span className="sr-only visually-hidden visually-hidden">Previous</span>
                            </button>
                            <button className="embla__button embla__button--next">
                                <span className="mobi-mbri mobi-mbri-arrow-next mbr-iconfont" aria-hidden="true"></span>
                                <span className="sr-only visually-hidden visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                </div>
            </section>
            <section data-bs-version="5.1" className="gallery1 cid-tbJKKZFylu" id="agallery1-39">
                <div className="container-fluid">
                    <div className="row">
                        <div className="item features-image сol-12 col-sm-6 col-lg-4">
                            <div className="item-wrapper">
                                <div className="item-img">
                                    <img src="/images/sams-solutions-qsk-ifuucwe-unsplash-916x609.jpg" alt=""
                                         title="" loading="lazy" className="lazyload"
                                         data-src="/images/sams-solutions-qsk-ifuucwe-unsplash-916x609.jpg"/>
                                    <div className="icon-box">
                                        <span className="mbr-iconfont mobi-mbri-right mobi-mbri"></span>
                                    </div>
                                </div>
                                <div className="item-content-container">
                                    <div className="item-content">
                                        <p className="mbr-text mbr-fonts-style display-4">
                                            <strong>Experienced Builders</strong>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="item features-image сol-12 col-sm-6 col-lg-4">
                            <div className="item-wrapper">
                                <div className="item-img">
                                    <img src="/images/evan-demicoli-efxxeo5cz74-unsplash-916x611.jpg" alt=""
                                         title="" loading="lazy" className="lazyload"
                                         data-src="/images/evan-demicoli-efxxeo5cz74-unsplash-916x611.jpg"/>
                                    <div className="icon-box">
                                        <span className="mbr-iconfont mobi-mbri-right mobi-mbri"></span>
                                    </div>
                                </div>
                                <div className="item-content-container">
                                    <div className="item-content">
                                        <p className="mbr-text mbr-fonts-style display-4">
                                            <strong>Fully Insured</strong>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="item features-image сol-12 col-sm-6 col-lg-4">
                            <div className="item-wrapper">
                                <div className="item-img">
                                    <Link to="/services">
                                        <img src="/images/c4b279-d4c5dc5a59664fd1b7000b8f30a1cc4df000-675x810.jpg" alt=""
                                             title="" loading="lazy" className="lazyload"
                                             data-src="/images/c4b279-d4c5dc5a59664fd1b7000b8f30a1cc4df000-675x810.jpg"/>
                                    </Link>
                                    <div className="icon-box">
                                        <span className="mbr-iconfont mobi-mbri-right mobi-mbri"></span>
                                    </div>
                                </div>
                                <div className="item-content-container">
                                    <div className="item-content">
                                        <p className="mbr-text mbr-fonts-style display-4">
                                            <strong>
                                                Expert Services
                                            </strong>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Partners/>
        </>
    );
}